import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAiHouse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <mask
      id="a"
      width={21}
      height={24}
      x={2}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill="#D9D9D9"
        fillRule="evenodd"
        d="M11.068 2.194a2.194 2.194 0 1 1-4.388 0 2.194 2.194 0 0 1 4.388 0m-1.153 0a1.042 1.042 0 1 1-2.083 0 1.042 1.042 0 0 1 2.083 0"
        clipRule="evenodd"
      />
      <path
        fill="#D9D9D9"
        d="M18.796 1.405c-.174-.593-1.014-.593-1.188 0l-.254.867a2.48 2.48 0 0 1-1.68 1.681l-.868.254c-.593.174-.593 1.014 0 1.188l.867.254c.81.237 1.444.87 1.681 1.68l.254.868c.174.593 1.014.593 1.188 0l.253-.867c.238-.81.871-1.444 1.682-1.681l.867-.254c.593-.174.593-1.014 0-1.188l-.867-.254a2.48 2.48 0 0 1-1.682-1.68zM12.747 9.311a1.92 1.92 0 0 1 2.16.028l4.57 3.197.046.033 2.666 1.742a.816.816 0 1 1-.893 1.367l-.999-.653v7.055c0 1.06-.86 1.92-1.92 1.92h-9.11a.96.96 0 1 1 0-1.92h9.11v-7.97l-4.57-3.197-1.595 1.055a.96.96 0 1 1-1.06-1.601z"
      />
      <path
        fill="#D9D9D9"
        d="M6.464 10.835c.239-.816 1.395-.816 1.634 0l.348 1.192a3.4 3.4 0 0 0 2.312 2.312l1.192.348c.816.239.816 1.395 0 1.634l-1.192.348a3.4 3.4 0 0 0-2.312 2.312l-.348 1.192c-.239.816-1.395.816-1.634 0l-.348-1.192a3.4 3.4 0 0 0-2.312-2.312l-1.192-.348c-.816-.239-.816-1.395 0-1.634l1.192-.348a3.4 3.4 0 0 0 2.312-2.312z"
      />
    </mask>
    <g mask="url(#a)">
      <circle cx={14.499} cy={11.329} r={21.262} fill="#FFC549" />
      <g filter="url(#b)">
        <ellipse
          cx={22.863}
          cy={3.602}
          fill="#FEC4FF"
          rx={18.425}
          ry={10.39}
          transform="rotate(-22.29 22.863 3.602)"
        />
      </g>
      <g filter="url(#c)">
        <ellipse
          cx={19.94}
          cy={19.976}
          fill="#FF9365"
          rx={13.835}
          ry={11.411}
          transform="rotate(-73.47 19.94 19.976)"
        />
      </g>
      <g filter="url(#d)">
        <ellipse
          cx={5.357}
          cy={-0.942}
          fill="#6B69FF"
          rx={7.407}
          ry={10.329}
          transform="rotate(-65.181 5.357 -.942)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="b"
        width={46.603}
        height={35.372}
        x={-0.439}
        y={-14.084}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_21_169"
          stdDeviation={2.9}
        />
      </filter>
      <filter
        id="c"
        width={45.258}
        height={49.316}
        x={-2.689}
        y={-4.682}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_21_169"
          stdDeviation={5.5}
        />
      </filter>
      <filter
        id="d"
        width={46.559}
        height={42.801}
        x={-17.922}
        y={-22.342}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_21_169"
          stdDeviation={6.7}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgAiHouse;
